import axios from 'axios';
import store from '../store';
import addError from './AddError';

export const REQUESTED_MQL_PLUS_PRICING = 'REQUESTED_MQL_PLUS_PRICING';
export const RECEIVED_MQL_PLUS_PRICING = 'RECEIVED_MQL_PLUS_PRICING';
export const REQUEST_MQL_PLUS_PRICING_FAILED = 'REQUEST_MQL_PLUS_PRICING_FAILED';

const getMqlPlusPricing = () => (
  (dispatch) => {
    dispatch({
      type: REQUESTED_MQL_PLUS_PRICING,
    });

    return axios.get('/api/features/mql-plus-leads/pricing')
      .then((response) => {
        dispatch({
          type: RECEIVED_MQL_PLUS_PRICING,
          data: response.data,
        });
      }).catch((error) => {
        dispatch({
          type: REQUEST_MQL_PLUS_PRICING_FAILED,
        });

        return store.dispatch(addError({
          text: 'Unable to fetch Mql Plus lead pricing',
          originalError: error,
        }));
      });
  }
);

export default getMqlPlusPricing;
